<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card-group mb-0">
            <div class="card p-4">
              <b-form>
                <div class="card-body text-center">
                  <h1>PAGE NOT FOUND</h1>
                  <b-button @click="back" variant="primary">Go Home</b-button>
                </div>
              </b-form>
            </div>
            <div
              class="card text-white py-5 d-md-down-none"
              style="width:44%; background-color: #ffffff"
            >
              <div class="card-body text-center">
                <div style="margin-top: 20%;">
                  <img src="img/logo.png" height="80" alt="logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      router.push({ name: "loan.agunanlist" });
    },
  },
};
</script>
